import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (res: any): { total: number } | null => {
  //   console.log(res.data);

  if (Object.keys(res.data).length) {
    return { total: res.data.data.total_earnings };
  }

  return null;
};

export const useGetTotalEarnings = ({
  dateRange,
  startDate,
  endDate,
  userId,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.totalEarningsWithFilters({
      dateRange,
      startDate,
      endDate,
      userId,
    }),
    queryFn: () => {
      return api.get("analytics/earnings/total", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          ...(userId && {
            staff_id: userId,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Total earnings]", res);
      handleErrors(res, "query");
    },
  });
};
